import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VwCommissionConfiguratorService {
  private url:string;

  ////////////////
  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  //
  getPromotions=(afiliateIds:any, paymentIds:any)=> {
    return this.http.get(`${this.url}/VwCommissionConfigurator/GetPromotions/${afiliateIds}/${paymentIds}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getPromotionsHM=()=> {
    return this.http.get(`${this.url}/VwCatPromotionHmController/Catalog`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  // catalogos
  getAfiliates=()=> {
    return this.http.get(`${this.url}/VwCommissionConfigurator/Catalog/Afiliate`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getAfiliatesByFinancingType=(financingTypeId:number[])=> {
    return this.http.post(`${this.url}/VwCommissionConfigurator/Catalog/AfiliatesByFinancingType`, financingTypeId)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getPayments=()=> {
    return this.http.get(`${this.url}/VwCommissionConfigurator/Catalog/Payment`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getPaymentTermsByAfiliate=(afiliateId:number[])=> {
    return this.http.post(`${this.url}/VwCommissionConfigurator/Catalog/PaymentTermsByAfiliate`, afiliateId)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getFinancingTypesByBusinessProduct=(businessProductId:number[])=> {
    return this.http.post(`${this.url}/VwCommissionConfigurator/Catalog/FinancingTypesByBusinessProduct`, businessProductId)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getFinancinfByAfiliatePayment=(params:any)=> {
    return this.http.post(`${this.url}/VwCommissionConfigurator/Catalog/FinancingByAfiliateAndPayment/`, params)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getFinancingByAfiliatePayment=(params:any)=> {
    return this.http.post(`${this.url}/VwCommissionConfigurator/Catalog/Offers/FinancingByAfiliateAndPayment/`, params)
      .pipe(
        map((resp:any)=> resp)
      );
  }
}
